import styled from "styled-components";

export default styled.span`
    font-size: 4rem;
    font-weight: bold;
    left: 16px;
    opacity: .1 !important;
    padding: -5px 0;
    position: absolute;
    text-transform: uppercase;
    top: -8px;
`;
